import { useMutation, useQueryClient } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';

/**
 * This is to track the mutation key for scanning a pod
 */
const MUT_SCAN_POD = 'scan-pod-mutation';

interface IScanPodMutationParam {
  onSuccess?: () => void;
  onError?: (err: IApiError) => void;
}

/**
 * React Query mutation function for scanning pod after adding a package to
 * the pod.
 */
export const useScanPodMutation = ({
  onSuccess,
  onError,
}: IScanPodMutationParam) => {
  const queryClient = useQueryClient();

  const { isPending, isError, error, data, mutate, isSuccess } = useMutation({
    mutationKey: [MUT_SCAN_POD],
    networkMode: 'always',
    mutationFn: INV_MGMT_SERVICE_API.scanPod,
    onSuccess: () => {
      queryClient.invalidateQueries();
      onSuccess?.();
    },
    onError,
  });

  return {
    data,
    isScanPodError: isError,
    isScanPodOngoing: isPending,
    isScanPodSuccess: isSuccess,
    scanPod: mutate,
    scanPodError: error,
  };
};
